import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { LoginStepBtnStyled } from "./loginStepBtn.styles";
import {
  selectLoginStep,
  selectLoginPhoneLoginIsLoading,
  selectLoginPhoneNumberIsValid,
  selectLoginPhoneNumber,
  selectLoginSentCode,
  selectLoginPhoneLoginConfirmIsLoading,
} from "../../redux/login/login.selectors";
import {
  fetchLoginPhoneAsync,
  fetchLoginPhoneConfirmAsync,
  fetchLoginNewUserAsync,
  setLoginStep,
} from "../../redux/login/login.actions";
import { useHistory } from "react-router";

const LoginStepBtn = ({
  loginStep,
  fetchLoginPhoneAsync,
  loginPhoneLoginIsLoading,
  loginPhoneNumberIsValid,
  selectLoginPhoneNumber,
  loginSentCode,
  fetchLoginPhoneConfirmAsync,
  loginPhoneLoginConfirmIsLoading,
  fetchLoginNewUserAsync,
}) => {
  const browserHistory = useHistory();

  const chooseText = () => {
    if (loginPhoneLoginIsLoading || loginPhoneLoginConfirmIsLoading)
      return (
        <div className="spinner-border text-secondary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      );
    console.log("loginStep", loginStep);
    switch (loginStep) {
      case 0:
        return "مرحله بعد";
      case 1:
        return "مرحله بعد";
      case 2:
        return "ورود";

      default:
        break;
    }
  };

  const handle_btn_click = () => {
    // alert("hi");
    console.log("step2", loginStep);
    switch (loginStep) {
      case 0:
        if (loginPhoneNumberIsValid && selectLoginPhoneNumber.length !== 0)
          fetchLoginPhoneAsync();
        break;
      case 1:
        if (loginSentCode.length === 6)
          fetchLoginPhoneConfirmAsync(browserHistory);
        break;
      case 2:
        fetchLoginNewUserAsync(browserHistory);
      default:
        break;
    }

    // setLoginStep(loginStep + 1);
  };

  return (
    <>
      <LoginStepBtnStyled>
        {loginStep !== -1 && (
          <button
            onClick={handle_btn_click}
            disabled={
              loginPhoneLoginIsLoading || loginPhoneLoginConfirmIsLoading
            }
          >
            {chooseText()}
          </button>
        )}
      </LoginStepBtnStyled>
      {/* {!(loginPhoneLoginIsLoading || loginPhoneLoginConfirmIsLoading) && (
        <LoadingPage isShow={true} />
      )} */}
    </>
  );
};
const mapStateToProps = createStructuredSelector({
  loginStep: selectLoginStep,
  selectLoginPhoneNumber: selectLoginPhoneNumber,
  loginPhoneLoginIsLoading: selectLoginPhoneLoginIsLoading,
  loginPhoneLoginConfirmIsLoading: selectLoginPhoneLoginConfirmIsLoading,
  loginPhoneNumberIsValid: selectLoginPhoneNumberIsValid,
  loginSentCode: selectLoginSentCode,
});

const mapDispatchToProps = (dispatch) => ({
  setLoginStep: (x) => dispatch(setLoginStep(x)),
  fetchLoginPhoneAsync: (x) => dispatch(fetchLoginPhoneAsync(x)),
  fetchLoginNewUserAsync: (x) => dispatch(fetchLoginNewUserAsync(x)),
  fetchLoginPhoneConfirmAsync: (x) => dispatch(fetchLoginPhoneConfirmAsync(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginStepBtn);
